export class UserNotifications {
    public constructor(init?: Partial<UserNotifications>) {
        Object.assign(this, init)
    }
    pipeline_integration_new_card = true
    scheduler_status_compareceu = false
}

export enum UserNotificationsEnum {
    pipeline_integration_new_card = 'pipeline_integration_new_card',
    scheduler_status_compareceu = 'scheduler_status_compareceu',
    direct = 'direct',
}
